import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=195e6e54"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=195e6e54&prod&lang=scss"
import style1 from "./Toolbar.vue?vue&type=style&index=1&id=195e6e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports